import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import images from "../../../images";
import { useTranslation } from "react-i18next";
import "../../../styles/animations.css";
import NewHeader from "../../Home/NewHeader";
import Button from "../../../components/common/Button/Button";
import { usePostHog } from "../../../hooks/usePostHog";

function QuestCompletionPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { trackEvent } = usePostHog();

  const location = useLocation();
  const { responseAnswer } = location.state || {};

  // Track quest completion page view
  React.useEffect(() => {
    const isUnderReview = responseAnswer?.data?.add_token === 0 && responseAnswer?.data?.add_xp === 0;
    
    trackEvent('quest_completion_page_viewed', {
      completion_status: isUnderReview ? 'under_review' : 'completed',
      coins_earned: responseAnswer?.data?.add_token || 0,
      xp_earned: responseAnswer?.data?.add_xp || 0,
      bonus_xp: responseAnswer?.data?.bonus_xp || 0,
      has_rewards: !isUnderReview
    });
  }, [responseAnswer, trackEvent]);

  const handleBackHome = () => {
    trackEvent('quest_completion_back_to_home', {
      completion_status: responseAnswer?.data?.add_token === 0 && responseAnswer?.data?.add_xp === 0 ? 'under_review' : 'completed',
      coins_earned: responseAnswer?.data?.add_token || 0
    });
    navigate("/");
  };

  const viewRewardClick = () => {
    trackEvent('quest_completion_view_rewards', {
      coins_earned: responseAnswer?.data?.add_token || 0,
      xp_earned: responseAnswer?.data?.add_xp || 0,
      bonus_xp: responseAnswer?.data?.bonus_xp || 0
    });
    navigate("/profile");
  };

  return (
    <div className="flex overflow-hidden flex-col mx-auto w-full bg-[#ECEEFF] max-w-[480px] ">
      <div className="flex flex-col w-full min-h-screen ">
        <div className="sticky top-0 left-0 w-full bg-white z-50">
          <NewHeader backgroundHeader="bg-[#ECEEFF]" />
        </div>
        {responseAnswer?.data?.add_token === 0 &&
        responseAnswer?.data?.add_xp === 0 ? (
          <div className="flex flex-col flex-1 justify-between p-4">
            <div className="flex flex-col items-center justify-center flex-1 gap-6">
              {/* Title */}
              <div className="text-center flex flex-col items-center gap-6">
                <div className="text-4xl font-bold text-[#253FF6]">
                  Quest under review
                </div>
                <div className="text-xl font-medium text-[#253FF6]">
                  We'll keep you posted when <br />
                  your points are ready!
                </div>
              </div>

              {/* Illustration */}
              <div className="flex justify-center items-center">
                <img
                  loading="lazy"
                  src={images.QuestUnderReview}
                  alt="Quest under review illustration"
                  className="w-[200px] h-auto"
                />
              </div>
              <div className="flex gap-3.5 items-start w-full">
                <Button
                  onClick={handleBackHome}
                  text={t("quest.taskQuest.exploreMoreQuests")}
                  className="flex-1 w-[284px] py-3 rounded-md min-h-[40px] text-xl font-medium text-[#253FF6] border border-solid border-[#253FF6]"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col flex-1 p-4 w-full gap-12">
            <div>
              <div className="flex flex-col p-4 mt-8 w-full ">
                <div className="self-center text-4xl font-bold text-[#253FF6]">
                  {t("quest.completedQuest.questCompleted")}
                </div>
                <div className="mt-3 text-xl font-medium text-center text-[#253FF6] ">
                  {t("quest.completedQuest.thanksForBeing")}
                </div>
              </div>
              <div className=" relative flex flex-col  justify-center items-center  w-full">
                <img
                  loading="lazy"
                  src={images.QuestCompletedImage}
                  alt="Quest completion illustration"
                  className=" w-[230px]  "
                />
                <div className="bg-white absolute top-[200px] w-full px-8 py-6 rounded-lg flex flex-col items-center justify-center ">
                  <div className="text-lg font-bold text-[#253FF6]">
                    Enjoy your rewards!
                  </div>
                  <div className="flex flex-row gap-2.5 items-center justify-between mt-3 text-[#253FF6]">
                    <div
                      className="flex flex-col gap-0.5 items-center bg-[#ECEEFF] p-2 rounded-md"
                      style={{ width: "133px" }}
                    >
                      <div>
                        <img
                          src={images.RallyCoinSmallBlueIcon}
                          className="w-4"
                          alt=""
                        />
                      </div>
                      <div className="text-xs font-medium">
                        {t("quest.taskQuest.rallyCoins")}
                      </div>
                      <div className="text-xl font-bold">
                        {responseAnswer?.data?.add_token}
                      </div>
                    </div>
                    <div
                      className="flex flex-col gap-0.5 items-center bg-[#ECEEFF] p-2 rounded-md"
                      style={{ width: "133px" }}
                    >
                      <div>
                        <img
                          src={images.RallyXPSmallBlueIcon}
                          className="w-4"
                          alt=""
                        />
                      </div>
                      <div className="text-xs font-medium">
                        {t("quest.taskQuest.expPts")}
                      </div>
                      <div className="text-xl font-bold">
                        {responseAnswer?.data?.add_xp}
                      </div>
                    </div>
                  </div>

                  <Button
                    onClick={viewRewardClick}
                    text={t("quest.taskQuest.viewRewards")}
                    className="flex-1 w-[284px] py-3 rounded-md min-h-[40px] text-xl font-medium text-white bg-[#253FF6]"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center gap-3.5 mt-[200px] w-full">
              {/* <Button
                                onClick={() =>
                                    navigate("/story-post", {
                                        state: {
                                            responseAnswer: {
                                                data: {
                                                    add_token: 300,
                                                    add_xp: 0,
                                                },
                                            },
                                        },
                                    })
                                }
                                icon={images.shareIcon}
                                text={t("quest.completedQuest.shareYourWins")}
                                className="flex-1 items-center w-[284px] py-3 rounded-md min-h-[40px] text-xl font-medium text-white bg-[#253FF6]"
                            /> */}
              <Button
                onClick={handleBackHome}
                text={t("quest.taskQuest.exploreMoreQuests")}
                className="flex-1 w-full py-3 rounded-md min-h-[40px] text-xl font-medium text-[#253FF6] border border-solid border-[#253FF6]"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default QuestCompletionPage;
